import { render, staticRenderFns } from "./ability.vue?vue&type=template&id=c8a36adc&scoped=true"
import script from "./ability.vue?vue&type=script&lang=js"
export * from "./ability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a36adc",
  null
  
)

export default component.exports